import "./NewTerminal.scss";
import { useNavigate } from "react-router-dom";
import primaryComponents from "../../../../components/primaryComponents";
import secondaryComponents from "../../../../components/secondaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import Images from "../../../../assets/images";

const NewTerminal = () => {
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Terminal"
      description="Request for a new terminal"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
        >
          <div className="new-terminal">
            <primaryComponents.Button
              classNames="btn btn--outline"
              onClick={() => navigate(-1)}
            >
              <FontAwesomeIcon
                icon="angle-left"
                className="mr-3"
                style={{ fontSize: "18px" }}
              />
              <span>Back</span>
            </primaryComponents.Button>
            <div className="new-terminal__header">
              <div>
                <h3 className="font-weight-semibold">Request POS Terminal</h3>
                <p>Please provide the following information</p>
              </div>
            </div>
            <div className="new-terminal__content">
              <secondaryComponents.TerminalRequestForm />
              <div className="new-terminal__content-img">
                <img src={Images.terminal_img} alt="POS Terminal" />
              </div>
            </div>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default NewTerminal;
